import { Form, Formik } from "formik";
import React, { FC, ReactElement, useEffect, useState } from "react";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { Tag } from "../../../models/Tag";
import WizardSideBarStep from "../../../models/WizardSideBarStep";
import Wizard from "../../wizard/wizard";
import DetailsForm from "../details-form";
import SummaryForm from "./summary-form";

interface Props {
    cardInfo: Tag;
    onSave: (values: Tag) => void;
    onClose: () => void
}

const EditCardWizard: FC<Props> = ({ cardInfo, onSave, onClose }) => {
    const { translate } = useLocale();
    const [step, setStep] = useState<number>(0)
    const [cardValues, setCardValues] = useState<Tag>(cardInfo);
    const initialCredential: Tag = {
        id: 0,
        code: '',
        type: '',
        typeId: "0",
        codeUntruncated: '',
        startDate: undefined,
        startTime: '',
        expiryDate: undefined,
        expiryTime: '',
        statusId: '1',
    };

    useEffect(() => {
        setCardValues(cardInfo);
    }, [cardInfo])

    const onNext = () => {
        setStep(step + 1);
    }

    const onBack = () => {
        setStep(step -1);
    }

    const content: ReactElement[] = [
        <DetailsForm
            onNext={onNext}
            onBack={onBack}
            cardInfo={cardValues}
            isEdit={true} />,
        <SummaryForm
            taskDescription={''}
            taskProcedure={''}
            onBack={onBack}
            isEdit={true} />
    ]

    const steps: WizardSideBarStep[] = [
        {
            title: translate.byKey(TranslationKeys.enterDetails),
            description: '',
            substeps: []
        },
        {
            title: translate.byKey(TranslationKeys.summary),
            description: '',
            substeps: []
        }
    ]

    return <Formik
        enableReinitialize={true}
        initialValues={initialCredential}
        onSubmit={onSave}>
        <Form>
            <Wizard name={translate.byKey(TranslationKeys.enrollCredential)}
                step={step}
                onClose={() => onClose()}
                sidebarSteps={steps}>
                {content}
            </Wizard>
        </Form>
    </Formik>
}

export default EditCardWizard;
